// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Brgd","inner":"Footer_inner__2xpXN"};